import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { STATUS_OPTIONS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/configs'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { FC, useCallback, useMemo } from 'react'

import { FormDropdown } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { useSafetyTranslation } from 'cng-common/features/translations'
import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'

import { createStatusCrud } from './configs'

interface IStatusProps {
  className?: string
  initialValue?: string
  isDisabled?: boolean
  formKey: string
}

export const Status: FC<IStatusProps> = ({ className, initialValue = '', isDisabled, formKey }) => {
  const t = useSafetyTranslation()
  const statusCrud = useMemo(() => createStatusCrud(t), [t])
  const handleValidateStatus = useCallback((value: string) => {
    return ValidationHelper.checkDropdown(
      normalizeKeyInitiativeStatus(value),
      STATUS_OPTIONS,
      'key'
    )
  }, [])

  return (
    <FormDropdown
      isStatic
      isRequired
      isDisabled={isDisabled}
      formKey={formKey}
      defaultValue={normalizeKeyInitiativeStatus(initialValue)}
      field="status"
      classes={{ controlClasses: { root: className } }}
      source={statusCrud}
      caption="label"
      label={TRANSLATION_KEYS.keyInitiativeEditor.focusStatus}
      onValidate={handleValidateStatus}
      validationType={ValidationType.ONCHANGE}
    />
  )
}

Status.displayName = 'Status'
